import React from 'react';
import { ImageMessage } from '@leagueplatform/genesis-core';
import {
  type MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { formatClassNames } from '../../utils/format-masonry-class-name.util';

const ImageAlignmentMap = {
  leading: 'start',
  center: 'center',
  trailing: 'end',
} as const;

type MasonryImageBannerNodeProperties = {
  image: string;
  imageAltText: string;
  imageHeight?: number;
  imageAlignment?: keyof typeof ImageAlignmentMap;
};

export type MasonryImageBannerNode = MasonryEngineNode<
  'imageBanner',
  MasonryImageBannerNodeProperties
>;

export type MasonryImageBannerRendererProps =
  MasonryEngineNodeRendererProps<MasonryImageBannerNode>;

export const MasonryImageBannerRenderer = ({
  image,
  imageAltText = '',
  imageHeight = 50,
  imageAlignment = 'center',
  className,
  engineClassName,
  locatorId,
  css,
  rootElementRef,
}: MasonryImageBannerRendererProps) => (
  <ImageMessage
    ref={rootElementRef}
    data-testid={locatorId}
    image={image}
    imageAlt={imageAltText}
    imageHeight={imageHeight}
    imageHorizontalAlignment={ImageAlignmentMap[imageAlignment]}
    className={formatClassNames(engineClassName, className)}
    css={{
      '.GDS-image': {
        objectFit: 'cover',
      },
      ...css,
    }}
  />
);
